<template>
  <b-modal
    id="set_setting"
    title="CONFIGURAÇÃO"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <label-required-field label="Nome" />
          <b-input ref="autofocus" :disabled="updating" v-model="name" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label-required-field label="Valor" />
          <b-input v-model="value" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <warning-required-fields />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <errors-messages :errors="errors" />
        </b-col>
      </b-row>
      <b-row align-h="between">
        <b-col cols="auto">
          <v-btn class="v-primary" @click="$bvModal.hide('set_setting')">
            VOLTAR
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn v-if="setting" class="v-danger ml-1" @click="del">
            EXCLUIR
          </v-btn>
          <v-btn type="submit" class="v-success ml-1"> SALVAR </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import LabelRequiredField from "../components/LabelRequiredField.vue";
import ErrorsMessages from "../components/ErrorsMessages.vue";
import WarningRequiredFields from "../components/WarningRequiredFields.vue";
import api from "../../services/api";
import toast from "../../components/ToastNotification";

export default {
  name: "SetSetting",

  components: {
    LabelRequiredField,
    ErrorsMessages,
    WarningRequiredFields,
  },

  props: {
    setting: Object,
  },

  data() {
    return {
      errors: [],
      updating: false,
      loading: false,

      name: "",
      value: "",
    };
  },

  watch: {
    setting(sett) {
      console.log("watch");
      if (!sett) {
        this.updating = false;
        this.name = "";
        this.value = "";
        return;
      }

      this.updating = true;
      this.name = sett.name;
      this.value = sett.value;

      this.$bvModal.show("set_setting");
    },
  },

  methods: {
    async evOnShow() {
      this.errors = [];
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = { name: this.name, value: this.value };
        const response = await api.post("/setting", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("set_setting");
          this.$emit("success");
          toast(message, "success");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async del() {
      try {
        this.loading = true;

        const params = { name: this.name };
        const response = await api.delete("/setting", { params });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("set_setting");
          this.$emit("success");
          toast(message, "success");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>